import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumericDirective } from './directives/numeric.directive';



@NgModule({
  declarations: [
    NumericDirective
  ],
  imports: [
    CommonModule
  ]
})
export class AppDirectiveModule { }
